import { shallowRef } from 'vue';

// The full icon library is ~150 KB of source, and only a page with a
// Buttons block needs it, so it loads on first use rather than riding
// in every public page's bundle. One shared load for every button.
export const iconLibrary = shallowRef(null);
let loading = null;
export function loadIconLibrary() {
    if (!loading) {
        loading = import('@/lib/iconLibrary.js')
            .then((m) => { iconLibrary.value = m; return m; })
            .catch(() => { loading = null; return null; });
    }
    return loading;
}
